// Web build entry point.
//
// Order matters. Importing './webPlatform' for its side effect assigns
// window.stenalWeb, which platform.ts (imported transitively by './main')
// resolves at module-eval time — so the adapter is installed first. Then we
// hard-gate on authentication: ensureAuthenticated() blocks on the login overlay
// until a valid, authorized stenal.net session exists, and only AFTER that do we
// dynamically import './main' (which boots the renderer). An unauthenticated user
// therefore never reaches boot() — no catalog loads, the app is unusable.
import './webPlatform';
import { ensureAuthenticated } from './webAuth';
import { mountWebMenu } from './webMenu';

async function start(): Promise<void> {
  await ensureAuthenticated();
  await import('./main'); // boot() runs on import — only now, post-auth
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountWebMenu);
  } else {
    mountWebMenu();
  }
}

void start();
